import '../less/ss-utils-styles.less';
import store from 'store';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { withRouter } from 'react-router-dom';
import { Popover, Divider, Icon } from 'antd';
import H2R from 'html-to-react';
let h2r = H2R.Parser();

export function getDataType( arg ) {
    return ( function( v ) {
        return ( v ).substring( v.indexOf( ' ' ) + 1, v.length - 1 );
    } )( Object.prototype.toString.call( arg ) );
}

export function simpleObjectCompare( obj1, obj2 ) {
    return JSON.stringify( obj1 ) === JSON.stringify( obj2 )
}
export function commonDataLookup( lookupState, category, group = 'Legacy' ) {
    const state = lookupState[category];
    if (!state)
        return [];

    return state
        .filter((lookup) => group === 'Legacy'
            ? (lookup.groups == null || lookup.groups.length === 0 || lookup.groups.includes(group))
            : (lookup.groups ? lookup.groups.includes(group) : false))
        .filter((value, index, self) =>
            // Remove duplicates
            index === self.findIndex((t) =>
                t.value === value.value));

}
export function isDisabled( bool ) {
    return bool
        ? true
        : false
}

export function countryCodeLookupcounterData( countryState, code ) {
    if ( code && countryState ) {
        const country = countryState[ code ];

        return country
            ? country.description
            : "";
    } else
        return "";
    }

export function stateCodeLookupcounterData( countryState, countryCode, StateCode ) {
    if ( countryCode && StateCode && countryState ) {
        const country = countryState[ countryCode ];
        let state = "";
        if ( country ) {
            state = country
                .states
                .find( row => ( row.code == StateCode ) );
        }
        return state
            ? state.description
            : "";
    } else
        return "";
    }

// converts column name to camel caseItem used by ss-analyst in several places dry!!
export function getColumnName( col ) {
    const tokens = col.split( "_" );
    let result = tokens[ 0 ].toLowerCase();
    for ( let i = 1; i < tokens.length; i++ ) {
        let tok = tokens[ i ];
        result = result.concat( tok[ 0 ].toUpperCase() + tok.substr( 1 ).toLowerCase() );
    }
    return result;
}

export function fileDownloadWithPost(url, params){
  const options = {
      credentials: 'include',
      method: 'post',
      body: JSON.stringify(params),
      headers: {
          Authorization: `Bearer ${ window.session.token }`,
          'Content-Type': 'application/json'
      }
  };


  fetch(url, options)
       .then(response => {
           const contentDisposition = response.headers.get('Content-Disposition');
            var filename = contentDisposition.substring(contentDisposition.indexOf("filename=")+9, contentDisposition.length);
       response.blob().then(blob => {
          if (window.navigator && window.navigator.msSaveOrOpenBlob) {
            window.navigator.msSaveOrOpenBlob(blob, filename);
            return;
          } else {
           var url = window.URL.createObjectURL(blob);
           var a = document.createElement('a');
           a.href = url;
           a.target="_blank";
           a.download = filename;
           document.body.appendChild(a); // we need to append the element to the dom -> otherwise it will not work in firefox
           a.click();
           a.remove();  //afterwards we remove the element again
       }})});
}

export function fileDownload(url){
    const options = {
        credentials: 'include',
        headers: {
            Authorization: `Bearer ${ window.session.token }`
        }
    };


    fetch(url, options)
        .then(response => {
            const contentDisposition = response.headers.get('Content-Disposition');
            var filename = contentDisposition.substring(contentDisposition.indexOf("filename=")+10, contentDisposition.length-1);
            response.blob().then(blob => {
                if (window.navigator && window.navigator.msSaveOrOpenBlob) {
                    window.navigator.msSaveOrOpenBlob(blob, filename);
                }else {
                    var url = window.URL.createObjectURL(blob);
                    var a = document.createElement('a');
                    a.href = url;
                    a.target="_blank";
                    a.download = filename;
                    document.body.appendChild(a); // we need to append the element to the dom -> otherwise it will not work in firefox
                    a.click();
                    a.remove();  //afterwards we remove the element again
  }})});
}

export function fetchImageWithAuthHeader( src, imgElement ) {

    const options = {
        credentials: 'include',
        headers: {
            Authorization: `Bearer ${ window.session.token }`
        }
    };

    fetch( src, options )
        .then( res => res.blob() )
        .then( blob => {
            imgElement.src = URL.createObjectURL( blob );
        } );
}

export function getMetaTagByName( name ) {

    const metas = document.getElementsByTagName( 'meta' );
    if ( metas ) {
        const foundMeta = metas.namedItem( name )

        if ( foundMeta ) {
            return foundMeta.content;
        }
    }
    return "";

}

export function parseRequestParams( queryParams ) {
    let returnVal = {};
    if ( queryParams ) {
        let params = queryParams.substring( 1 );
        params = params.split( "&" );
        params.forEach( param => {
            const pair = param.split( "=" );
            if(pair[1]){
              returnVal[ pair[ 0 ] ] = pair[ 1 ].replace(new RegExp('%20', 'g'), ' ');
            } else {
              returnVal[ pair[ 0 ] ] = pair[ 1 ];
            }
        } )
    }
    return returnVal;
}

export function parseRequestParamsWithArrays( queryParams ) {
    let returnVal = {};
    if ( queryParams ) {
        let params = queryParams.substring( 1 );
        params = params.split( "&" );
        params.forEach( param => {
            const pair = param.split( "=" );
            if(!returnVal[ pair[ 0 ] ]){
                  returnVal[ pair[0] ] = []
                  returnVal[ pair[0] ].push(pair[1]);
            } else {
              returnVal[ pair[ 0 ] ].push(pair[ 1 ]);
            }
        } )
    }
    return returnVal;
}

export function hasDataLoaded( arrayOfRequestObjects ) {
    try {
        const total = arrayOfRequestObjects.length;
        let returnVal = 0;

        arrayOfRequestObjects.forEach( req => {
            if ( req.loadTime > 0 )
                returnVal++;
            }
        );

        return {
            elementsLoaded: returnVal,
            total: total,
            loaded: total === returnVal,
            inError: false
        };
    } catch ( error ) {
        return { elementsLoaded: 0, total: 0, inError: true };
    }
}

export function reverseLookup( lookupState, category, value ) {
    if ( !value )
        return '---';
    else {
        const state = lookupState[ category ];
        if ( state ) {
            const returnVal = state.find( item => item.value ? (isNaN(item.value) ? item.value.toUpperCase() === value.toUpperCase() : item.value == value) : false );
            if ( !returnVal )
                return '---';
            return returnVal.name;
        } else
            return '';
        }
}

export function checkLookup( lookupState, category, value ) {
    if (!value )
        return '---';
    else {
        const state = lookupState[ category ];
        if ( state ) {
            const returnVal = state.find( item => item.value ? (isNaN(item.value) ? item.value.toUpperCase() === value.toUpperCase() : item.value == value) : false );
            if ( !returnVal )
                return '---';
            return returnVal.value;
        } else
            return '';
    }
}

export function reverseGroupLookup(lookupState, category, group, value) {
    if (!value)
        return '---';

    if (!group)
        return reverseLookup(lookupState, category, value);

    const state = lookupState[category];
    if (!state)
        return '';

    const returnVal = state.find(item => item.groups.includes(group) && (item.value ? (isNaN(item.value) ? item.value.toUpperCase() === value.toUpperCase() : item.value == value) : false));
    return returnVal ? returnVal.name : '---';
}

export function Request() {
    this.status = null;
    this.code = null;
    this.error = null;
}

export function setEnvPrefix( endpoint ) {
    let isPrefixed = undefined;

    const KNOWN_ENV_PREFIXES = [
            '/dev', '/test', '/staging'
        ],

        path = window.location.pathname;

    KNOWN_ENV_PREFIXES.forEach( prefix => {
        if ( path.startsWith( prefix ) )
            isPrefixed = prefix;
        }
    );

    if ( isPrefixed ) {
        return `${ isPrefixed}${ endpoint }`;
    }

    return endpoint;
}

export function getNumberFromString( str ) {
    let no = 0;
    str
        .split( '' )
        .map( c => no += c.charCodeAt( 0 ) );
    return no;
}

export const log = ( env => {
    let consoleObj = {},
        consoleMethods = [ 'log', 'warn', 'error' ];
    for ( let type in consoleMethods ) {
        let t = null;
        switch ( consoleMethods[ type ] ) {
            case 'log':
                t = 'msg';
                break;
            default:
                t = consoleMethods[ type ];
        }
        consoleObj[ t ] = function() {
            if ( env === 'development' )
                console[ consoleMethods[ type ] ].apply( console, arguments );
            }
        }
    return consoleObj;
} )( process.env.NODE_ENV )

export function ajax( request ) {
    let xhr = new XMLHttpRequest(),
        // Use the configuration in the request to parse out the data from the response when
        // passing it back.
        dataFormatter = ( d ) => {
            if ( request.hasOwnProperty( 'headers' ) ) {
                for ( let h in request.headers ) {
                    let headerType = request.headers[ h ];
                    switch ( h ) {
                        case 'Content-Type':
                            switch ( headerType ) {
                                case 'application/json':
                                    d = JSON.parse( d );
                                    break;
                            }
                            break
                    }
                }
            }
            return d;
        },
        getContentType = () => {
            let contentType = {};
            for ( let h in request.headers )
                contentType = request.headers[ h ];
            return contentType;
        };

    xhr.onreadystatechange = () => {
        const { readyState, status } = xhr;
        if ( readyState == XMLHttpRequest.DONE ) {
            let obj = {},
                success = request.types[1],
                failure = request.types[ 2 ];

            switch ( ( status + '' ).charAt( 0 ) ) {
                    // General success 2xx series of responses.
                case '2':
                    if ( getDataType( success ) === 'Object' ) {
                        store.dispatch( success.payload( success.type, status, xhr.responseText ) );
                    } else if ( getDataType( success ) === 'String' )
                        return {
                            meta: {
                                status: 'success',
                                code: status
                            },
                            type: success,
                            payload: dataFormatter( xhr.responseText )
                        };

                    break;

                    // General failure with the 4xx series of responses.
                case '4':
                    if ( getDataType( failure ) === 'Object' ) {
                        store.dispatch( failure.payload( failure.type, status, xhr.responseText ) );
                    } else if ( getDataType( failure ) === 'String' )
                        return {
                            meta: {
                                status: 'failure',
                                code: status
                            },
                            type: failure,
                            payload: dataFormatter( xhr.responseText )
                        };

                    break;
            }
        }
    }

    xhr.open( request.method, setEnvPrefix( request.endpoint ), true );
    xhr.setRequestHeader( 'Content-Type', getContentType() );

    if ( request.hasOwnProperty( 'useToken' ) && request.useToken )
        xhr.setRequestHeader( 'Authorization', `Bearer ${ window.session.token }` );

    switch ( request.method ) {
        case 'GET':
            xhr.send();
            break;
        case 'POST':
            xhr.send( request.body );
            break;
    }

    return { type: request.types[ 0 ] };
}

export function Container( _connect, _class ) {
    let { services } = _connect;

    if ( _connect.state == null )
        _connect.state = function( state ) {
            return { state }
        };

    services = serviceFormatter( services ) || [];
    _connect.withRouter = !!_connect.withRouter;

    if ( _connect.withRouter ) {
        return withRouter( connect( state => _connect.state( state ), dispatch => ( {
            services: bindActionCreators( Object.assign( {}, services ), dispatch )
        } ) )( _class ) );
    } else {
        return connect( state => _connect.state( state ), dispatch => ( {
            services: bindActionCreators( Object.assign( {}, services ), dispatch )
        } ) )( _class )
    }
}

function serviceFormatter( services ) {
    let servicesList = {};

    services.map( ( _services ) => {
        switch ( getDataType( _services ) ) {
            case 'Object':
                for ( let s in _services )
                    servicesList[ s ] = _services[ s ];
                break;

            case 'Array':
                let source = _services[ 0 ];
                for ( let i = 1; i < _services.length; i++ ) {
                    let s = _services[ i ];
                    servicesList[ s ] = source[ s ];
                }
                break;
        }
    } );

    return servicesList;
}

export function getPathParams() {
    let
    result = {},
    params = window.location.search;

    if (params != null && params !== '') {
        ((params.substring(1, params.length)).split('&')).forEach(e => {
            let tokens = e.split('=');
            result[tokens[0]] = tokens[1];
        });
        return result;
    } else return null;
}

export class IconPopover extends React.Component {
    constructor(props) { super(props); }
    render() {
        const { title, header, placement, children, centered, noTitle, style, iconStyle, noAbsolute } = this.props;
        return (
            <div style={style}>
                <Popover placement={placement || 'top'} content={(
                    <div className='ss-utils-popover-div-outer'>
                        <div className='ss-utils-popover-div-inner-divider'>
                            <Divider>
                                <span className='ss-utils-popover-div-inner-divider-span'>
                                    {header}
                                </span>
                            </Divider>
                        </div>
                        <div className='ss-utils-popover-div-inner-content'>
                            {children}
                        </div>
                    </div>
                )}>
                    <div className={noAbsolute ? 'ss-utils-popover-child-div-no-absolute' : 'ss-utils-popover-child-div'} style={
                        centered != null && centered === 'x' ? { transform: 'translateX(-50%)', left: '50%' }
                        : centered != null && centered === 'y' ? { transform: 'translateY(-50%)', top: '50%' }
                        : centered != null && centered === 'xy' ? { transform: 'translateX(-50%) translateY(-50%)', top: '50%', left: '50%' }
                        : centered == null ? { transform: 'translateX(-50%)', left: '50%' }
                        : {}
                    }>
                        <span className='ss-utils-popover-child-div-span'>
                            <Icon type='exclamation-circle-o' style={noTitle ? iconStyle : {...iconStyle, marginRight: '6px' }} />
                            {noTitle ? null : title}
                        </span>
                    </div>
                </Popover>
            </div>
        );
    }
}

export class HTMLRender extends React.Component {
    render() {
        const { h2rConfig, divProps, value } = this.props;

        // html-to-react 'Parser' configuration format.
        // See: https://www.npmjs.com/package/html-to-react
        if(h2rConfig != null) h2r = H2R.Parser(h2rConfig);

        return (
            <div {...divProps}>
                {h2r.parse(value)}
            </div>
        );
    }
}

export function xfsb(obj) {
    var str = '';
    for (var p in obj)
        str += p + '=' + obj[p] + '&';
    return str.substring(0, str.length - 1);
}

export function formRedirect(path, params, method) {
    method = method || "post";

    var form = document.createElement("form");
    form.setAttribute("method", method);
    form.setAttribute("action", path);

    for (var key in params)
        if(params.hasOwnProperty(key)) {
            var hiddenField = document.createElement("input");
            hiddenField.setAttribute("type", "hidden");
            hiddenField.setAttribute("name", key);
            hiddenField.setAttribute("value", params[key]);

            form.appendChild(hiddenField);
        }

    document.body.appendChild(form);
    form.submit();
}
